import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import { getCustomers, selectCustomers } from "redux/slices/customerSlice";
import { addOrder } from "redux/slices/orderSlice";
import OrderForm from "components/Orders/form";
import LightLayout from "components/Shared/LightLayout";
import Navbar from "components/Navbar";
import { selectUser } from "redux/slices/userSlice";

const currentAction = "ADD";

const AddOrder = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const customers = useSelector(selectCustomers);
  const user = useSelector(selectUser);

  useEffect(() => {
    if (!customers.length) {
      if (user?.permissions?.customers?.admin) {
        dispatch(getCustomers(true, { where: { duplicate: false, active: true } }));
      } else {
        dispatch(
          getCustomers(true, {
            where: {
              supplier_id: user?.supplier_id,
              duplicate: false,
              active: true,
            },
          })
        );
      }
    }
  }, [dispatch, user]);

  const onSubmit = async (payload) => {
    try {
      const res = await dispatch(addOrder(payload));
      if (res) {
        history.push(PATHS.orders.root);
      }
    } catch (err) {
      // Keep form intact on error so user doesn't lose input data
    }
  };

  return (
    <>
      <Navbar />
      <LightLayout>
        <OrderForm onSubmit={onSubmit} action={currentAction} customerList={customers} />
      </LightLayout>
    </>
  );
};

export default AddOrder;
